import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '30%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialBy',
    label: 'Testimonial By',
    width: '20%',
    align: 'left',
    dataKey: 'testimonialBy',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialTab',
    label: 'Testimonial Tab',
    width: '15%',
    align: 'left',
    dataKey: 'testimonialTab',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialCategory',
    label: 'Testimonial Category',
    width: '15%',
    align: 'left',
    dataKey: 'testimonialCategory',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    width: '10%',
    align: 'right',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  {
    action: ACTIONS.TRANSLATE.value,
    label: ACTIONS.TRANSLATE.label,
  },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_TESTIMONIAL_TEXT_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialBy',
    label: 'Testimonial By',
    dataKey: 'testimonialBy',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialTab',
    label: 'Testimonial Tab',
    dataKey: 'testimonialTab',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'testimonialCategory',
    label: 'Testimonial Category',
    dataKey: 'testimonialCategory',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'sequence',
    label: 'Sequence',
    dataKey: 'sequence',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created Date',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];
